// removed by extract-text-webpack-plugin
module.exports = {"testimonialCardContainer":"testimonialCardContainer__2iM4r","testimonialName":"testimonialName__2C1eF","testimonialDesc":"testimonialDesc__17MhI"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVD/testimonials/testimonialCard/style.css
// module id = 7n5v
// module chunks = 446